import React from "react";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";

interface FormFieldProps {
  label: string;
  type?: string;
  placeholder?: string;
  maxLength?: number;
  showCounter?: boolean;
  error?: FieldError;
  value?: string;
  className?: string;
  register?: UseFormRegisterReturn;
}

export function FormField({
  label,
  type = "text",
  placeholder,
  maxLength,
  showCounter = false,
  error,
  value = "",
  className = "",
  register,
}: FormFieldProps) {
  return (
    <div className={className}>
      <label className="block text-gray-bb-1 font-medium mb-2">{label}</label>
      <input
        {...register}
        type={type}
        maxLength={maxLength}
        className={`w-full border rounded-lg p-3 focus:ring-2 focus:ring-blue-bb focus:border-transparent ${
          error ? "border-red-500" : "border-gray-bb-4"
        }`}
        placeholder={placeholder}
      />
      {showCounter && maxLength && (
        <div className="text-right text-sm text-gray-bb-2 mt-1">
          Caracteres: {value?.length || 0}/{maxLength}
        </div>
      )}
      {error && (
        <p className="text-red-500 text-sm mt-1">{error.message}</p>
      )}
    </div>
  );
}